module.exports = __webpack_public_path__ + "static/media/kioskLogo.7d987d83.png";